import type { FeatureRoute } from '../registry';
import { GiftCardLogsPage } from './GiftCardLogsPage';
import { ItemTrailsPage } from './ItemTrailsPage';
import { PriceGroupPricesPage } from './PriceGroupPricesPage';

export const routes: FeatureRoute[] = [
  { path: 'items/:id/trails', element: <ItemTrailsPage /> },
  { path: 'price-groups/:id/prices', element: <PriceGroupPricesPage /> },
  { path: 'gift-cards/:id/logs', element: <GiftCardLogsPage /> }
];
